import { OwnerAccessRequestDto } from '../dto'
import { OwnerAccessRequestModel } from '../models'

export const ownerAccessRequestDtoToModelTransformer = (values: OwnerAccessRequestDto[]): OwnerAccessRequestModel[] => {
  return values.map(value => ({
    id: value.id,
    accountLinkId: value.accountLinkId,
    installationId: value.installationId,
    companyName: value.companyName,
    createdAt: value.createdAt,
    reason: value.reason,
    decision: value.decision,
  }))
}
